import * as React from "react";
import { SVGProps } from "react";

export const IconUploadSuccessful = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm6-12.637L14.605 6l-6.42 6.274-2.79-2.725L4 10.91 8.184 15 16 7.363z"
      fill="#8BCC8D"
    />
  </svg>
);
